<template>
  <div>
    <v-tabs v-model="tabs" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab ripple :key="'voucher-code-details'" :href="'#voucher-code-details'">
        {{ $t('Voucher Code Details') }}
      </v-tab>
    </v-tabs>

    <div v-if="tabs == 'voucher-code-details'">
      <VoucherCodeDetails></VoucherCodeDetails>
    </div>
  </div>
</template>

<script>
import VoucherCodeDetails from './VoucherCodeDetails.vue'

export default {
  components: {
    VoucherCodeDetails
  },
  data() {
    return {
      tabs: 'voucher-code-details'
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/plern/main.vue